$(document).ready(function () {
  zermatusaInitFunctions();
  //zermatusaSendMundialRegisterDataToPixelsTest();
});

function zermatusaInitFunctions() {
  zermatusaPrintLogBeauty("Cargando funciones ZermatUSA...");
  zermatusaPrintLog(
    "Idioma actual en la tienda",
    zermatusaGetCurrentLanguage(),
  );
  if (window.location.search === "?clearCache") {
    zermatusaClearAffiliateCacheAndCookies();
  }
}

function zermatusaIsMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

function zermatusaGetCurrentLanguage() {
  let language = "en";
  if (window.location.pathname.startsWith("/es")) language = "es";
  return language;
}

function zermatusaPrintLogBeauty(message) {
  console.log(
    "%c \u25BA zermatusa-functions.js --> " + message,
    "background-color: #FF0B53; color: #fff; padding: 5px;",
  );
}

function zermatusaPrintLog(message, data) {
  if (data !== undefined)
    console.log("zermatusa-functions.js --> " + message + ":", data);
  else console.log("zermatusa-functions.js --> " + message);
}

function zermatusaClearAffiliateCacheAndCookies(mode) {
  zermatusaDeleteCacheEntry("ref");
  zermatusaDeleteCookie("ref", window.location.host);
  zermatusaDeleteCookie("ref");
  window.location = window.location.pathname;
}

function zermatusaDeleteCacheEntry(name) {
  localStorage.removeItem(name);
}

function zermatusaDeleteCookie(name, domain = "", path = "/") {
  document.cookie =
    name +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;" +
    "path=" +
    path +
    ";" +
    (domain ? "domain=" + domain + ";" : "");
}

function zermatusaPrintMyIp() {
  fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => {
      zermatusaPrintLog("IP pública", data.ip);
    });
}

function zermatusaParseTags(str) {
  return (str || "")
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
}

function zermatusaHasTag(tags, tag) {
  return tags.indexOf(tag) !== -1;
}

function zermatusaComputeRules(button) {
  const productTags = zermatusaParseTags(button.dataset.productTags);
  const customerTags = zermatusaParseTags(button.dataset.customerTags);
  const textAdd = button.dataset.textAdd;
  const textPreorder = button.dataset.textPreorder;
  const textAffiliate = button.dataset.textAffiliate;
  const isB2B = zermatusaHasTag(customerTags, "B2B");
  const isMontoB = zermatusaHasTag(productTags, "MONTOB");
  const isPreorder = zermatusaHasTag(productTags, "Preorder");

  const textSpan = button.querySelector(".btn__text");
  if (!textSpan) return;

  // Tu logica Liquid
  let canBuyProduct = true;

  if ((isMontoB || isPreorder) && isB2B) {
    canBuyProduct = true;
  } else if (isMontoB || isPreorder) {
    canBuyProduct = false;
  }

  if (!canBuyProduct) {
    button.disabled = true;
    button.classList.add("is-tag-blocked");
    textSpan.textContent = textAffiliate;
    return;
  } else if (isPreorder) {
    button.disabled = false;
    button.classList.remove("is-tag-blocked");
    textSpan.textContent = textPreorder;
    return;
  } else {
    button.disabled = false;
    button.classList.remove("is-tag-blocked");
    textSpan.textContent = textAdd;
  }
}

function zermatusaUpdateAllButtons() {
  document
    .querySelectorAll(".js-zermatusa-logic")
    .forEach(zermatusaComputeRules);
}

// Al cargar
document.addEventListener("DOMContentLoaded", function () {
  zermatusaUpdateAllButtons();
  zermatusaWatchStickyBar();
});

// Hyper: evento oficial al cambiar variante
document.addEventListener("variant:changed", function (evt) {
  //zermatusaPrintLog("event variant:changed");
  zermatusaUpdateAllButtons();
});

function zermatusaWatchStickyBar() {
  const sticky = document.querySelector(".sticky-atc-bar");
  if (!sticky) return;

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.attributeName === "class") {
        if (sticky.classList.contains("sticky-atc-bar--show")) {
          zermatusaUpdateAllButtons();
        }
      }
    }
  });

  observer.observe(sticky, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

function zermatusaAddToCartProducts(products) {
  zermatusaPrintLog(
    "Agregando al carrito los productos indicados...",
    products,
  );

  // Send the request to Shopify's AJAX Cart API
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(products),
  })
    .then((response) => {
      // if (!response.ok) {
      //   throw new Error('Network response was not ok');
      // }
      return response.json();
    })
    .then((data) => {
      console.log("data", data);
      //Out of stock status (422) or invalid variant ID (400)
      if (data.status === 422 || data.status === 400) {
        showToast(`Error: ${data.description}`, "error");
      } else if(data.status === 'too_many_requests') {
        showToast(`Error: ${data.message}. ${data.description}`, "error");
      } else {
        //zermatusaPrintLog('Successfully added items', data);
        zermatusaUpdateCartDrawer();
      }
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    });
}

function zermatusaAddProductToCartFromButton(ids, qtys) {
  //zermatusaPrintLog('zermatusaAddProductToCartFromButton...');
  //zermatusaPrintLog('ids', ids);
  //zermatusaPrintLog('qtys', qtys);
  if (ids !== undefined && ids !== "" && qtys != undefined && qtys !== "") {
    //zermatusaPrintLog('zermatusaAddProductToCartFromButton -> Entro if 1');
    let idsArray = ids.split("|");
    let qtysArray = qtys.split("|");
    //zermatusaPrintLog(`zermatusaAddProductToCartFromButton -> idsArray.length: ${idsArray.length}, qtysArray.length ${qtysArray.length}`);

    if (idsArray.length === qtysArray.length) {
      //zermatusaPrintLog('zermatusaAddProductToCartFromButton -> Entro if 2');
      let formData = { items: [] };
      for (let index = 0; index < idsArray.length; index++) {
        formData.items.push({
          id: idsArray[index], // The ID of the product variant
          quantity: qtysArray[index], // The quantity to add
        });
      }
      //zermatusaPrintLog('Agregando al carrito productos del boton...', formData);
      zermatusaAddToCartProducts(formData);
    }
  }
}

const scrollIntoViewWithHeaderOffset = (targetView) => {
  const target = document.getElementById(targetView);
  if (target) {
    let headerOffset = 0;
    const header = document.querySelector("header.header");
    //console.log("header", header);
    if (header) {
      //console.log("header data", header.getBoundingClientRect());
      headerOffset = header.getBoundingClientRect().height;
    }
    const elementPosition = target.getBoundingClientRect().top;
    //Add 16px of padding top
    const offsetPosition =
      elementPosition + window.pageYOffset - headerOffset - 32;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

// Se dejo de usar a partir del 21 de Mayo de 2026, se deja porque sirve para enviar eventos custom a Google Analytics y Pixeles
function zermatusaSendMundialRegisterDataToPixelsTest() {
  zermatusaPrintLog(
    "Enviando datos de prueba a los pixeles para verificar que funcionen correctamente",
  );
  let formData = {
    fullName: "Nombre Test",
    email: "jflores@zermatusa.com",
    phone: "+525555555555",
    orderId: "#9999",
    city: "TX",
    salesChannel: 1,
    acceptTermsAndConditions: true,
    lang: "en",
    transactionId: "12345", // El folio o id que retorna tocayo del registro exitoso
  };
  zermatusaSendMundialRegisterDataToPixels(formData);
}

// Se dejo de usar a partir del 21 de Mayo de 2026, se deja porque sirve para enviar eventos custom a Google Analytics y Pixeles
function zermatusaSendMundialRegisterDataToPixels(formData) {
  zermatusaPrintLog(
    "Enviando datos a los pixeles de Meta, Tiktok y Google Tag Manager",
    formData,
  );
  let zermatusaEventId = formData?.orderId + "|" + formData?.transactionId; // Creamos un id de evento con los datos del envio
  zermatusaPrintLog("Zermat Event ID", zermatusaEventId);

  // Pixel Meta, si funciona
  zermatusaPrintLog("Enviando evento a pixel de meta...");
  //zermatusaPrintLog('Validando variable fbq', fbq);

  if (typeof fbq === "function") {
    fbq("track", "Lead", {
      content_category: "registro_campania", // Solo informativo
      content_name: "campania_mundial_2026", // Nombre de la campania
      promotion_name: "campania_mundial_2026", // Nombre de la campania
      value: 1, // Conteo de la persona registrada +1
      status: "completed", // Indica que el evento del registro se ha realizado bien
      content_ids: [zermatusaEventId], // Util para identificar el evento generado a nivel interno
      transaction_id: zermatusaEventId, // Util para identificar el evento generado a nivel interno
      customer_type: "existing_customer", // Indica que el cliente ya existe
    });
  }

  // Google Analytics GA4, GTM (Google Tag Manager), si funciona
  zermatusaPrintLog("Enviando evento a google tag manager...");
  //zermatusaPrintLog('Validando variable gtag', gtag);

  if (typeof gtag === "function") {
    gtag("event", "generate_lead", {
      form_name: "registro_campania", // Solo informativo
      promotion_name: "campania_mundial_2026", // Nombre de la campania
      value: 1, // Conteo de la persona registrada +1
      transaction_id: zermatusaEventId, // Util para identificar el evento generado a nivel interno
      customer_type: "existing_customer", // Indica que el cliente ya existe
    });
  }

  // Google Ads, si funciona
  zermatusaPrintLog("Enviando evento a google ads...");
  //zermatusaPrintLog('Validando variable gtag', gtag);

  if (typeof gtag === "function") {
    gtag("event", "conversion", {
      send_to: "AW-434575788", // Identificador del tag de la cuenta de google ads
      value: 1, // Conteo de la persona registrada +1
      transaction_id: zermatusaEventId, // Util para identificar el evento generado a nivel interno
    });
  }

  // Google Tag Manager (DataLayer), si funciona
  zermatusaPrintLog(
    "Enviando evento a google tag manager a traves del dataLayer...",
  );
  //zermatusaPrintLog('Validando variable window.dataLayer', window.dataLayer);

  if (window.dataLayer !== undefined) {
    window.dataLayer.push({
      event: "campania_mundial_2026",
      form_name: "registro_campania", // Solo informativo
      promotion_name: "campania_mundial_2026", // Nombre de la campania
      value: 1, // Conteo de la persona registrada +1
      transaction_id: zermatusaEventId, // Util para identificar el evento generado a nivel interno
      customer_type: "existing_customer", // Indica que el cliente ya existe
    });
  }

  // Pixel Tiktok, si funciona
  zermatusaPrintLog("Enviando evento a pixel de tiktok...");
  //zermatusaPrintLog('Validando variable ttq', ttq);

  if (ttq !== undefined) {
    ttq.track("SubmitForm", {
      content_name: "campania_mundial_2026", // Nombre de la campania
      form_name: "registro_campania", // Solo informativo
      transaction_id: zermatusaEventId, // Util para identificar el evento generado a nivel interno
      value: 1, // Conteo de la persona registrada +1
    });
  }
}

function showToast(message, type) {
  const toast = document.getElementById("custom-toast");
  const toastText = toast.querySelector(".toast-message");
  toastText.innerText = message;

  // if (type === "error") {
  //   toast.classList.add("toast-error");
  // } else {
  //   toast.classList.remove("toast-error");
  // }

  toast.classList.add(`${type}-status`);


  toast.classList.add("toast-visible");
  toast.classList.remove("toast-hidden");

  setTimeout(() => {
    toast.classList.add("toast-hidden");
    toast.classList.remove("toast-visible");
  }, 4000);
}

function zermatusaUpdateCartDrawer() {
  // Update cart
  document.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        open: true,
      },
    }),
  );
}